import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { for: "lastname" }
const _hoisted_3 = { for: "firstName" }
const _hoisted_4 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email *", -1)
const _hoisted_6 = { for: "phoneNo" }
const _hoisted_7 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_8 = { for: "street" }
const _hoisted_9 = { for: "streetNo" }
const _hoisted_10 = { for: "zip" }
const _hoisted_11 = { for: "city" }
const _hoisted_12 = { for: "country" }
const _hoisted_13 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_14 = { class: "p-field p-col" }
const _hoisted_15 = { for: "selfEstimation" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "p-field p-col" }
const _hoisted_18 = { for: "certificate" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["p-field p-col", {'pError':_ctx.$store.state.errors.lastName}])
      }, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('login.lastName')) + " *", 1),
        _createVNode(_component_InputText, {
          id: "lastname",
          class: "p-inputtext-sm",
          type: "text",
          autocomplete: "family-name",
          modelValue: _ctx.editableUser.lastName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editableUser.lastName) = $event)),
          placeholder: "Pilz",
          disabled: _ctx.disabled
        }, null, 8, ["modelValue", "disabled"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["p-field p-col", {'pError':_ctx.$store.state.errors.firstName}])
      }, [
        _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('login.firstName')) + " *", 1),
        _createVNode(_component_InputText, {
          id: "firstName",
          class: "p-inputtext-sm",
          type: "text",
          autocomplete: "given-name",
          modelValue: _ctx.editableUser.firstName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editableUser.firstName) = $event)),
          placeholder: "Hannah",
          disabled: _ctx.disabled
        }, null, 8, ["modelValue", "disabled"])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["p-field p-col", {'pError':_ctx.$store.state.errors.email}])
      }, [
        _hoisted_5,
        _createVNode(_component_InputText, {
          id: "email",
          class: "p-inputtext-sm",
          type: "email",
          autocomplete: "email",
          disabled: _ctx.disabled,
          modelValue: _ctx.editableUser.email,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editableUser.email) = $event)),
          placeholder: "hannah.pilz@example.ch"
        }, null, 8, ["disabled", "modelValue"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["p-field p-col", {'pError':_ctx.$store.state.errors.phoneNo}])
      }, [
        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('login.phoneNo')), 1),
        _createVNode(_component_InputText, {
          id: "phoneNo",
          class: "p-inputtext-sm",
          type: "tel",
          autocomplete: "tel",
          modelValue: _ctx.editableUser.phoneNo,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editableUser.phoneNo) = $event)),
          placeholder: "+41999999999",
          disabled: _ctx.disabled
        }, null, 8, ["modelValue", "disabled"])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(["p-field p-col", {'pError':_ctx.$store.state.errors.street}])
      }, [
        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('login.street')), 1),
        _createVNode(_component_InputText, {
          id: "street",
          class: "p-inputtext-sm",
          type: "text",
          autocomplete: "street-address",
          modelValue: _ctx.editableUser.street,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editableUser.street) = $event)),
          placeholder: "Pilzweg",
          disabled: _ctx.disabled
        }, null, 8, ["modelValue", "disabled"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["p-field p-col", {'pError':_ctx.$store.state.errors.streetNo}])
      }, [
        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('login.streetNo')), 1),
        _createVNode(_component_InputText, {
          id: "streetNo",
          class: "p-inputtext-sm",
          type: "text",
          modelValue: _ctx.editableUser.streetNo,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editableUser.streetNo) = $event)),
          disabled: _ctx.disabled
        }, null, 8, ["modelValue", "disabled"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["p-field p-col", {'pError':_ctx.$store.state.errors.zip}])
      }, [
        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('login.zip')), 1),
        _createVNode(_component_InputText, {
          id: "zip",
          class: "p-inputtext-sm",
          type: "text",
          autocomplete: "postal-code",
          min: "1000",
          max: "9999",
          modelValue: _ctx.editableUser.zip,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editableUser.zip) = $event)),
          disabled: _ctx.disabled
        }, null, 8, ["modelValue", "disabled"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["p-field p-col", {'pError':_ctx.$store.state.errors.city}])
      }, [
        _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('login.city')), 1),
        _createVNode(_component_InputText, {
          id: "city",
          class: "p-inputtext-sm",
          type: "text",
          autocomplete: "address-level2",
          modelValue: _ctx.editableUser.city,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editableUser.city) = $event)),
          disabled: _ctx.disabled,
          readonly: "",
          onfocus: "this.removeAttribute('readonly');"
        }, null, 8, ["modelValue", "disabled"])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["p-field p-col", {'pError':_ctx.$store.state.errors.country}])
      }, [
        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('login.country')), 1),
        _createVNode(_component_Dropdown, {
          id: "country",
          modelValue: _ctx.editableUser.country,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editableUser.country) = $event)),
          disabled: _ctx.disabled,
          options: _ctx.countryOptions,
          optionLabel: "LABEL",
          optionValue: "ID",
          placeholder: _ctx.$t('choose_dropdown'),
          filter: true,
          filterPlaceholder: _ctx.$t('search'),
          class: "p-mb-2",
          showClear: true
        }, null, 8, ["modelValue", "disabled", "options", "placeholder", "filterPlaceholder"])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('login.how_experienced')), 1),
        _hoisted_16,
        _createVNode(_component_Dropdown, {
          id: "selfEstimation",
          modelValue: _ctx.editableUser.selfEstimation,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editableUser.selfEstimation) = $event)),
          disabled: _ctx.disabled,
          options: _ctx.selfEstimationOptions,
          optionLabel: "LABEL",
          optionValue: "ID",
          placeholder: _ctx.$t('choose_dropdown'),
          filter: true,
          filterPlaceholder: _ctx.$t('search'),
          class: "p-mb-2",
          showClear: true
        }, null, 8, ["modelValue", "disabled", "options", "placeholder", "filterPlaceholder"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('login.certificate')), 1),
        _hoisted_19,
        _createVNode(_component_MultiSelect, {
          id: "certificate",
          modelValue: _ctx.editableUser.certificates,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editableUser.certificates) = $event)),
          disabled: _ctx.disabled,
          options: _ctx.certificateOptions,
          optionLabel: "LABEL",
          optionValue: "ID",
          placeholder: _ctx.$t('choose_dropdown'),
          filter: true,
          filterPlaceholder: _ctx.$t('search'),
          class: "p-mb-2",
          showClear: true
        }, null, 8, ["modelValue", "disabled", "options", "placeholder", "filterPlaceholder"])
      ])
    ])
  ], 64))
}